
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Toque em "Abrir no navegador..."`,
's182ab2d6c997515f': `Adicione à Tela de Início para uma melhor experiência e mais fácil acesso.`,
's224cbcec014ef6b5': `Pressione Compartilhar na barra de endereço`,
's233af3b7eb5e0364': `Adicionar à página inicial`,
's37a9e8aec5713460': `Mais`,
's4c3161035f3a1413': `Pressione Menu`,
's4e1e10a6ca408245': `Toque em "Adicionar à Tela de Início"`,
's6196153c4b0c1ea0': `Instalar`,
's633502f7cff4f847': `Abra o menu do seu navegador`,
's681e399d63311fba': `Mostrar Galeria`,
's6d14a4f70ba4e3cf': `Pressione Menu se não houver ícone de Compartilhar`,
's922329d6f6213590': `Adicionar ao Dock`,
's9c63a79ffcc2a3a3': `Pressione "Adicionar à Tela de Início"`,
'sa2d71bfd9525168d': `Pressione "Adicionar ao Dock"`,
'sa5ef80b4bb9b39f8': `Menos`,
'sb527eca1c1d7e7be': `Abra o menu do navegador integrado`,
'sba52286c21552a4e': `Instale no dispositivo para uma melhor experiência e mais fácil acesso.`,
'sc16e00a7a8b2fde2': `Voltar`,
'scdaf4bbff76674c8': `Adicionar à Tela de Início`,
'sd18a5b85f599ff3c': `Abra o link copiado no Safari`,
'se72fc3a84f9b51c3': `Toque para copiar o link`,
'se740f75b95a51807': `Adicione ao Dock para uma melhor experiência e mais fácil acesso.`,
'sfa6c42cdf48d93d2': `Mas este navegador não oferece suporte a esse recurso. Abra o link em um navegador externo para continuar.`,
'sfb78526365796a41': `Pressione "Ver mais" no menu Compartilhar`,
'sfea652f6580ff086': `Este site possui funcionalidade de aplicativo.`,
    };
  